import {filterPaidInclusions} from './hop-native-purchase-rules.js';
/* Presentation adapter only. Native brand code supplies prices, quantities, eligibility and cart action. */
import {mountPurchaseComponents} from './napoleon-ui.js?shipping-stock-20261027';
import {purchaseBenefitsData} from './hop-purchase.js?shipping-stock-20261027';
const config=document.querySelector('[data-hop-native-purchase]');
if(config) {
 const root=document.querySelector(config.dataset.root);
 const data=JSON.parse(document.querySelector('#hop-purchase-data').textContent);
 let renderer,hosts,frame;
 const scrollTo=target=>{
  if(!target)return;
  if(target.matches('details'))target.open=true;
  target.querySelector('button[aria-expanded=false]')?.click();
  target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
  target.querySelector('summary,button,input,a')?.focus({preventScroll:true});
 };
 const render=()=>{
  frame=null;
  const state=root?.hopPurchaseRead?.();
  if(!state)return;
  const price=root.querySelector(state.priceSelector),purchase=root.querySelector(state.purchaseSelector);
  if(!price||!purchase)return;
  root.setAttribute('data-hop-purchase','');
  root.querySelectorAll('.service-card').forEach(card=>{if(/^Hassle[ -]free returns$/i.test(card.querySelector('strong')?.textContent.trim()||''))card.setAttribute('data-hop-redundant-policy','');});
  if(!renderer){
   hosts=Object.fromEntries(['price','benefits','sticky'].map(key=>{const node=document.createElement('div');node.dataset.hopNativeHost=key;return[key,node]}));
   renderer=mountPurchaseComponents(hosts);root.append(hosts.sticky);
  }
  // Native renderers can replace the anchor on model changes. Keep one mounted host per role.
  if(price.nextElementSibling!==hosts.price)price.after(hosts.price);
  const rating=root.querySelector(state.ratingsSelector||'.hop-rating-links');
  if(rating){if(hosts.price.nextElementSibling!==rating)hosts.price.after(rating);if(rating.nextElementSibling!==hosts.benefits)rating.after(hosts.benefits);}
  else if(hosts.price.nextElementSibling!==hosts.benefits)hosts.price.after(hosts.benefits);
  const variant={...data.variants[state.sku],id:state.id,price:state.unitCents,available:state.available};
  const currentData={...data,variants:{...data.variants,[state.sku]:variant}};
  const paymentTerms=document.querySelector('#hop-purchase-payment-form shopify-payment-terms');
  if(paymentTerms&&state.id&&paymentTerms.getAttribute('variant-id')!==String(state.id))paymentTerms.setAttribute('variant-id',String(state.id));
  const warranty=root.querySelector(state.warrantySelector||'#fire-warranty,#accessory-warranty') || [...root.querySelectorAll('details,[data-slot=accordion-item]')].find(node=>/^(Care & warranty|Manufacturer warranty|Product documents & warranty)/i.test(node.querySelector('summary,button')?.textContent.trim()||''));
  if(warranty&&!warranty.id)warranty.id='hop-native-warranty';
  const benefits=purchaseBenefitsData(currentData,state.category,state.handle,state.sku,state.leadTime);
  // Delivery follows the selected product stock, independently of required bundle choices.
  benefits.shipping_available=data.variants[state.sku]?.available ?? state.available;
  benefits.included_accessories=filterPaidInclusions(benefits.included_accessories,state.paidAccessories||[]);
  renderer.render({
   price:{data:benefits,variantId:state.id,unitPriceCents:state.financing===false?null:state.unitCents},
   benefits:{data:benefits,warranty:!!warranty,warrantyTarget:warranty?'#'+warranty.id:undefined,openWarranty:()=>scrollTo(warranty)},
   sticky:{...state,rootSelector:config.dataset.root,cartUrl:data.cart_url,variantId:id=>id,
    editTarget:()=>scrollTo(root.querySelector(state.editSelector)),onAdd:state.onAdd}
  });
 };
 const schedule=()=>{if(!frame)frame=requestAnimationFrame(render)};
 document.addEventListener('hop:native-purchase-state',schedule);
 root?.addEventListener('input',schedule);root?.addEventListener('change',schedule);root?.addEventListener('click',schedule);
 document.addEventListener('cart:refresh',schedule);
 const observer=new MutationObserver(records=>{if(records.some(r=>!r.target.closest?.('[data-hop-native-host]')))schedule()});
 if(root)observer.observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled']});
 if(data.inclusions_url)fetch(data.inclusions_url).then(r=>r.ok?r.json():null).then(inclusions=>{if(inclusions){data.inclusions=inclusions;schedule()}}).catch(()=>{});
 schedule();
}
